import { useEffect, useState } from "react";

/**
 * useMediaQuery — Hook léger qui suit l'état d'une media query.
 *
 * @example
 *   const isMobile = useMediaQuery("(max-width: 599px)");
 *
 * SSR-safe : retourne `false` côté serveur.
 * Optimisé : un seul listener par instance, cleanup automatique.
 */
export default function useMediaQuery(query) {
  const getMatch = () => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatch);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;

    const mql = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);

    // Sync immédiat (le query a pu changer)
    setMatches(mql.matches);

    // addEventListener moderne, fallback addListener pour vieux Safari
    if (mql.addEventListener) {
      mql.addEventListener("change", handler);
      return () => mql.removeEventListener("change", handler);
    }
    mql.addListener(handler);
    return () => mql.removeListener(handler);
  }, [query]);

  return matches;
}
